import log from 'chameleon/packages/blue-book-player/utility/log';

const errorHandler = (error) => {
  log.error(error);
  if (
    window.LearnosityItems &&
    window.LearnosityItems.errors &&
    window.LearnosityItems.errors.length
  ) {
    log.error(window.LearnosityItems.errors);
  }
  if (
    window.LearnosityApp &&
    window.LearnosityApp.errors &&
    window.LearnosityApp.errors.length
  ) {
    log.error(window.LearnosityApp.errors);
  }
  if (
    window.LearnosityAssess &&
    window.LearnosityAssess.errors &&
    window.LearnosityAssess.errors.length
  ) {
    log.error(window.LearnosityAssess.errors);
  }
};

export default errorHandler;
